/* EVOKE: plain text for everything saved on an order line.
   Parex (Shopify -> MYOB) shortens long text by bytes, which breaks on special characters
   (long dashes, curly quotes, (TM), accents, emoji) and the order then fails to sync.
   Customers still see what they typed on the page; only the copy saved to the order is cleaned. */
(function () {
  function plain(t) {
    if (t === null || t === undefined) return t;
    t = String(t);
    if (/^[\x09\x0A\x0D\x20-\x7E]*$/.test(t)) return t;            /* already plain */
    t = t.replace(/[\u2018\u2019\u201a\u201b\u2032`\u00b4]/g, "'")
         .replace(/[\u201c\u201d\u201e\u201f\u2033\u00ab\u00bb]/g, '"')
         .replace(/[\u2010-\u2015\u2212\u2043\ufe58\ufe63\uff0d]/g, '-')
         .replace(/\u2026/g, '...')
         .replace(/[\u00d7\u2715\u2716]/g, 'x')
         .replace(/[\u2022\u00b7\u2027]/g, '-')
         .replace(/[\u00a0\u2000-\u200a\u202f\u205f\u3000]/g, ' ')
         .replace(/[\u200b-\u200d\u2060\ufeff]/g, '')
         .replace(/\u00df/g, 'ss').replace(/\u00c6/g, 'AE').replace(/\u00e6/g, 'ae')
         .replace(/\u00d8/g, 'O').replace(/\u00f8/g, 'o').replace(/\u0152/g, 'OE').replace(/\u0153/g, 'oe')
         .replace(/[\u2122\u00ae\u00a9]/g, '');
    if (t.normalize) t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    t = t.replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');                 /* emoji and anything else */
    return t.replace(/ {2,}/g, ' ');
  }
  /* JSON values (e.g. _names) are cleaned inside, so they stay valid JSON */
  function plainValue(v) {
    if (typeof v !== 'string') return v;
    var s = v.trim();
    if ((s.charAt(0) === '{' || s.charAt(0) === '[') && /[^\x20-\x7E]/.test(s)) {
      try { return JSON.stringify(deep(JSON.parse(s))); } catch (e) {}
    }
    return plain(v);
  }
  function deep(o) {
    if (typeof o === 'string') return plain(o);
    if (Array.isArray(o)) return o.map(deep);
    if (o && typeof o === 'object') { var r = {}; for (var k in o) if (o.hasOwnProperty(k)) r[plain(k)] = deep(o[k]); return r; }
    return o;
  }
  /* a line's properties object: clean names and values */
  function plainProps(p) {
    if (!p || typeof p !== 'object') return p;
    var r = {};
    for (var k in p) if (p.hasOwnProperty(k)) r[plain(k)] = plainValue(p[k]);
    return r;
  }
  /* request body for /cart/add.js or /cart/change.js */
  function plainCartData(d) {
    if (!d || typeof d !== 'object') return d;
    if (d.properties) d.properties = plainProps(d.properties);
    if (Array.isArray(d.items)) d.items.forEach(function (i) { if (i && i.properties) i.properties = plainProps(i.properties); });
    return d;
  }
  /* every properties[...] field in the given forms (names and values; file fields keep their file) */
  function plainForms(forms) {
    for (var f = 0; f < forms.length; f++) {
      var els = forms[f].querySelectorAll('[name^="properties["]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i], n = el.getAttribute('name'), pn = plain(n);
        if (pn !== n) el.setAttribute('name', pn);
        if (el.type === 'file' || el.type === 'checkbox' || el.type === 'radio') continue;
        if (typeof el.value === 'string') { var pv = plainValue(el.value); if (pv !== el.value) el.value = pv; }
      }
    }
  }
  window.xoPlain = { text: plain, value: plainValue, props: plainProps, cartData: plainCartData, forms: plainForms };
})();
